import React from "react";
import { BrowserRouter } from "react-router-dom";
import {
  AppInsightsErrorBoundary,
  withAITracking,
} from "@microsoft/applicationinsights-react-js";

import { UserModuleResponse } from "../../models/Api/Modules";
import AppContent from "../containers/AppContent";
import { reactPlugin } from "../../utils/logHandlers/appInsight";
import errorPage from "../../components/errorPages/404";

export interface PropsFromState {
  moduleData: UserModuleResponse;
}

type AllProps = PropsFromState;

const App: React.FC<AllProps> = ({ moduleData }) => {
  return (
    <AppInsightsErrorBoundary
      onError={() => errorPage()}
      appInsights={reactPlugin}
    >
      <BrowserRouter>
        <AppContent moduleData={moduleData} />
      </BrowserRouter>
    </AppInsightsErrorBoundary>
  );
};

export default withAITracking(reactPlugin, App);
